import { render } from "./NewLeadModal.vue?vue&type=template&id=dd5c3fa4"
import script from "./NewLeadModal.vue?vue&type=script&lang=js"
export * from "./NewLeadModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__